<template>
  <main v-if="!loading" class="category">
    <div class="main__container">
      <div class="page__header">
        <h1 class="page__title">{{ feed?.title }}</h1>
      </div>
      <MovieLists :movieListData="feed?.premium_contents" :watchingProps="watchingData" />
    </div>
  </main>
</template>

<script setup>

import { computed } from 'vue';
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import MovieLists from '@/components/layouts/MovieLists.vue';

const store = useStore();
const route = useRoute();
const slug = route.params.slug;
const isSlug = (item) => item.slug === slug;
const loading = computed(() => store.state.categories.categoryData.loading)
const feed = computed(() => store.state.categories.categoryData.data.premium_categories[0].premium_groups.find(isSlug))
const watchingData = computed(() => store.state.categories.watching.data)

store.dispatch('categories/loadCategoryData', 'home');
</script>

<style lang="scss" scoped>
.main__container {
  padding-top: rem(80);

  @include media-breakpoint-down(xs) {
    padding-top: rem(40);
  }
}
</style>
